<img class="img-background-right-bottom" src= "../../../assets/img/Medicin.png">
<img class="img-background-left-bottom" src= "../../../assets/img/Medicin.png">
<div class="authentication-wrapper authentication-basic container-p-y">
    <div class="authentication-inner py-4">
        <div class="card">
            <header style="align-self: center;">
                <a href="index.html" class="app-brand-link gap-1 mt-3">
                    <span class="app-brand-logo demo top-logo me-2">
                        <img src="../../assets/img/pendar-logo.png">
                    </span>
                    <span class="app-brand-text demo h3 mb-0 fw-bold ps-2">{{ 'APPName' | translate }}</span>
                    <language [classSize]="'fs-1'"></language>
                </a>
            </header>
            <div class="card-body ">               
                <router-outlet></router-outlet>
            </div>
            <app-version-tag></app-version-tag>
        </div>
    </div>
</div>